/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd and/or Orbit Tickets Ltd. All rights reserved.
This file contains a combination of:
- Protected Intellectual Property owned by Kaleida Ltd; and
- Custom / Included Intellectual Property owned by the Customer,
and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (being any application not developed by Kaleida), whether or not such application forms part of the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, where separation between Protected Intellectual Property and Custom / Included Intellectual Property is unclear, this file shall be treated as containing Protected Intellectual Property.
*/

// IP-NOTICE: MIXED
import { Injectable } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BlockUiService {
  @BlockUI() blockUI: NgBlockUI;
  useBlockUi = true;
  blocking = false;
  context = '';

  protected blockerStarted = new Subject<void>();
  // Observable blockerStarted stream
  blockerStarted$ = this.blockerStarted.asObservable();
  protected blockerStopped = new Subject<void>();
  // Observable blockerStopped stream
  blockerStopped$ = this.blockerStopped.asObservable();

  constructor() {
    console.log(`BlockUiService constructor`);
  }

  stopBlockUI(context: string) {
    this.context = context;
    // if(this.blockUI.isActive === false) {
    //     console.log(`BlockUiService.stopBlockUI: blockUI is not active. Skipping stopBlockUI. context: ${context}`);
    //     return;
    // }
    console.log(`BlockUiService.stopBlockUI: context: ${context}`);
    if (this.useBlockUi) {
      this.blockUI.stop();
      this.blocking = false;
      this.blockerStopped.next();
    }
  }

  startBlockUI(context: string) {
    this.context = context;
    console.log(`BlockUiService.startBlockUI: context: ${context}`);
    // if(this.blockUI.isActive === true) {
    //     console.log(`BlockUiService.startBlockUI: blockUI is already active. Skipping startBlockUI. context: ${context}`);
    //     return;
    // }
    if (this.useBlockUi && this.blockUI.isActive === false) {
      this.blockUI.start();
      this.blocking = true;
      this.blockerStarted.next();

    }
  }
}
